<template>
    <div>
        <van-cell-group>
            <van-cell title="每周租金	" :value="propertyData.pwPrice"/>
            <van-cell title="押金" :value="propertyData.bond"/>
            <van-cell title="起租时间" :value="propertyData.availableDate"/>
            <van-cell title="类型" :value="propertyData.propertyType"/>
            <van-cell title="户型">
                <template #label>
                    <span style="margin-right: 30px">BEDROOMS: x{{propertyData.bedrooms}}</span>
                    <span style="margin-right: 30px">BATHROOMS: x{{propertyData.bathrooms}}</span>
                    <span v-if="propertyData.park">PARK: x{{propertyData.park}}</span>
                </template>
            </van-cell>
<!--            <van-cell title="中文描述" label="描述信息">
                <template #label>
                    <div v-html="propertyData.cnDescription"></div>
                </template>
            </van-cell>-->
            <van-cell title="房源图片集" label="图片集">
                <template #label>
                    <van-image v-for="(img, imgIdx) in propertyData.images"
                               style="margin-right: 3px;"
                               width="100"
                               height="100"
                               lazy-load
                               @click="preview(propertyData.images, imgIdx)"
                               :src="img.url || img"
                    />
                </template>
            </van-cell>
            <van-cell title="户型图" label="户型图" v-if="propertyData.floorImages && propertyData.floorImages.length > 0">
                <template #label>
                    <van-image v-for="(img, imgIdx) in propertyData.floorImages"
                               style="margin-right: 3px;"
                               width="100"
                               height="100"
                               lazy-load
                               @click="preview(propertyData.floorImages, imgIdx)"
                               :src="img.url || img"
                    />
                </template>
            </van-cell>
            <van-cell title="VR在线看房" v-if="vrUrl.length>0">
                <template v-if="vrUrl.length==1">
                    <span class="vr-see" @click="seeVr(vrUrl[0])">VR看房</span>
                </template>
                <template v-else  slot="label" >
                 <span v-for="(item, idx) in vrUrl" class="vr-see" :key="item"  style="margin-right: 10px;"
                       @click="seeVr(item)">VR看房{{idx+1}}</span>
                </template>
            </van-cell>
            <van-cell title="地理位置" label="地理位置">
                <template #label>
                    <map-cmp :address="propertyData.address"
                             :latitude="propertyData.latitude"
                             :longitude="propertyData.longitude"
                             :map-img-desc="propertyData.mapImgDesc"
                    />
                </template>
            </van-cell>

        </van-cell-group>
    </div>
</template>

<script>
    import {ImagePreview} from 'vant';
    import MapCmp from './mapCmp';
    export default {
        name: "realestate",
        props: {
            modelStr: {
                type: String,
                default: ''
            },
        },
        components: {
            MapCmp
        },
        data() {
            return {
                propertyData: JSON.parse(this.modelStr)
            }
        },
        computed: {
            vrUrl() {
                return this.propertyData.vrs || [];
            }

        },
        created() {

        },
        methods: {
            preview(fileList, idx) {
                let images = []
                fileList.map(it => {
                    images.push(it.url || it)
                })
                ImagePreview({
                    images: images,
                    startPosition: idx
                });
            },
            seeVr(url) {
                window.open(url)
            }
        }
    }
</script>

<style scoped lang="scss">
    .vr-see {
        font-weight: bold;
        color: #1b86ea;
        font-size: 12px;
    }
</style>
